import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useToggleRequestAttachmentSelected = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ attachmentId }) => handler({
    type: actions.TOGGLE_REQUEST_ATTACHMENT_SELECTED, category, code, attachmentId,
  }), [category, code]);
};

const useToggleRequestAttachmentColumnOrderBy = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ orderByColumn }) => handler({
    type: actions.TOGGLE_REQUEST_ATTACHMENT_COLUMN_ORDER_BY, category, code, orderByColumn,
  }), [category, code]);
};

const useToggleRequestAttachmentTypeFilter = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ attachmentType }) => handler({
    type: actions.TOGGLE_REQUEST_ATTACHMENT_TYPE_FILTER, category, code, attachmentType,
  }), [category, code]);
};

const useUpdateRequestAttachmentTextFilter = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ text }) => handler({
    type: actions.UPDATE_REQUEST_ATTACHMENT_TEXT_FILTER, category, code, text,
  }), [category, code]);
};

const useRequestAttachmentFolderPush = (category, { code }) => {
  const handler = useDispatch();

  return useCallback(({ folder }) => handler({
    type: actions.REQUEST_ATTACHMENT_FOLDER_PUSH, category, code, folder,
  }), [category, code]);
};

const useRequestAttachmentFolderNavigate = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ segments }) => handler({
    type: actions.REQUEST_ATTACHMENT_FOLDER_NAVIGATE, category, code, segments,
  }), [category, code]);
};

const useToggleRequestAttachmentsSelected = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ selected }) => handler({
    type: actions.TOGGLE_REQUEST_ATTACHMENTS_SELECTED, category, code, selected,
  }), [category, code]);
};

const useFetchRequestAttachments = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ permissions, allowPmnTransfer }) => handler({
    type: actions.FETCH_REQUEST_ATTACHMENTS, category, code, permissions, allowPmnTransfer,
  }), [category, code]);
};

export default {
  useFetchRequestAttachments,
  useRequestAttachmentFolderNavigate,
  useRequestAttachmentFolderPush,
  useToggleRequestAttachmentSelected,
  useToggleRequestAttachmentsSelected,
  useToggleRequestAttachmentColumnOrderBy,
  useToggleRequestAttachmentTypeFilter,
  useUpdateRequestAttachmentTextFilter,
};
